module.exports = __webpack_public_path__ + "733c4dfa8be0aa95d3fbcf86375ba541.svg";